import {
  ArrowDownIcon,
  ArrowUpIcon,
  isMobileAtom,
  useRecoil,
} from '@orcar/common-d2c';
import { useState } from 'react';
import styled from 'styled-components';

type NoticeCardProps = {
  title: string;
  date: string;
  detail: string;
};

const NoticeCard = ({ title, date, detail }: NoticeCardProps) => {
  const { recoilValue: isMobile } = useRecoil(isMobileAtom);
  const [isOpened, setIsOpened] = useState(false);

  return (
    <Wrapper isMobile={isMobile}>
      <NoticeWrapper onClick={() => setIsOpened(!isOpened)}>
        <NoticeInfoBox isMobile={isMobile}>
          <NoticeTitle isMobile={isMobile}>{title}</NoticeTitle>
          <NoticeDate>{date}</NoticeDate>
        </NoticeInfoBox>

        {isOpened ? (
          <ToggleIcon
            src={ArrowUpIcon}
            width={isMobile ? 12 : 16}
            height={isMobile ? 21 : 25}
            alt='토글'
          />
        ) : (
          <ToggleIcon
            src={ArrowDownIcon}
            width={isMobile ? 12 : 16}
            height={isMobile ? 21 : 25}
            alt='토글'
          />
        )}
      </NoticeWrapper>
      {isOpened && <NoticeDetail isMobile={isMobile}>{detail}</NoticeDetail>}
    </Wrapper>
  );
};

export default NoticeCard;

const Wrapper = styled.div<{ isMobile: boolean }>`
  width: ${({ isMobile }) => (isMobile ? '320px' : '777.6px')};
  margin: ${({ isMobile }) => isMobile && '0 auto'};
  padding: ${({ isMobile }) => (isMobile ? '24px 0' : '30px 0')};
  border-bottom: ${({ theme }) => `1px solid ${theme.COLOR.GREY_05}`};
`;

const NoticeWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  cursor: pointer;
`;

const NoticeInfoBox = styled.div<{ isMobile: boolean }>`
  display: flex;
  flex-direction: ${({ isMobile }) => isMobile && 'column'};
  justify-content: ${({ isMobile }) => !isMobile && 'space-between'};
  width: ${({ isMobile }) => !isMobile && '737px'};
  gap: ${({ isMobile }) => isMobile && '8px'};
`;

const ToggleIcon = styled.img`
  cursor: pointer;
`;

const NoticeTitle = styled.div<{ isMobile: boolean }>`
  ${({ theme }) => theme.FONT.H4};
  font-weight: 500;
  font-size: ${({ isMobile }) => (isMobile ? '16px' : '18px')};
`;

const NoticeDate = styled.div`
  ${({ theme }) => theme.FONT.B2};
  font-weight: 400;
  color: ${({ theme }) => theme.COLOR.GREY_02};
`;

const NoticeDetail = styled.p<{ isMobile: boolean }>`
  margin-top: 16px;
  ${({ theme, isMobile }) => (isMobile ? theme.FONT.B2 : theme.FONT.B1)};
  font-weight: 300;
  white-space: pre-line;
`;
